import { Box, Grid, Stack } from "@mui/material";

import { UnauthenticatedFeaturebaseWrapper } from "components/UnauthenticatedFeaturebaseWrapper";

import { BG_ICON_COLOR } from "../../../constants";
import { useIsMobile } from "../../../hooks/useIsMobile";

interface Props {
  authComponent: React.ReactNode;
  /**
   * Drops the branding half and lets the content use the full viewport. Sign-in
   * sized forms want the narrow column; a page rendering a whole shipment and
   * quote form does not fit in it.
   */
  wide?: boolean;
}

export function MainLayout(props: Props) {
  const { authComponent, wide = false } = props;

  const isMobileLayout = useIsMobile({ maxWidth: 700 });
  const showBrandingPanel = !isMobileLayout && !wide;

  return (
    <Grid container minHeight="100vh">
      <UnauthenticatedFeaturebaseWrapper />
      {showBrandingPanel && (
        <Grid
          item
          sm={4}
          md={6}
          bgcolor={BG_ICON_COLOR}
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <img
            style={{ height: "200px", width: "200px" }}
            alt="badge logo"
            src="/images/e_logo.jpg"
          />
        </Grid>
      )}
      <Grid item xs={12} sm={showBrandingPanel ? 8 : 12} md={wide ? 12 : 6}>
        <Box sx={!isMobileLayout ? { flexGrow: 1 } : null}>
          <Stack alignItems="center">
            <Box
              mt={isMobileLayout ? "2rem" : "4rem"}
              width={wide ? "100%" : "60%"}
            >
              {authComponent}
            </Box>
          </Stack>
        </Box>
      </Grid>
    </Grid>
  );
}
